// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__DdiSn","checkboxCol":"Table_checkboxCol__1OEjG","emailCol":"Table_emailCol__xclVW","actionCol":"Table_actionCol__1GSZg"};